/**
 * Role selector component for choosing between Teacher and Student roles
 */

import React from 'react';
import { UserIcon, TeacherIcon } from './SvgConsolidated/SvgIcons';

interface RoleSelectorProps {
  onRoleSelected: (role: 'teacher' | 'student') => void;
}

export default function RoleSelector({ onRoleSelected }: RoleSelectorProps) {
  return (
    <div className="bg-white rounded-2xl shadow-xl p-8 max-w-2xl w-full">
      <div className="text-center mb-8">
        <h1 className="text-4xl font-bold text-gray-800 mb-4">
          Welcome to Learning Companion
        </h1>
        <p className="text-gray-600 text-lg">
          Choose your role to get started.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        {/* Student Role */}
        <button
          onClick={() => onRoleSelected('student')}
          className="group relative overflow-hidden p-6 rounded-2xl bg-gradient-to-br from-blue-500 to-purple-600 text-white hover:from-blue-600 hover:to-purple-700 transform hover:scale-105 transition-all duration-300 shadow-xl hover:shadow-2xl"
        >
          <div className="absolute inset-0 bg-white/10 group-hover:bg-white/20 transition-colors duration-300" />
          
          <div className="relative z-10 text-center">
            <div className="mb-4 flex justify-center">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center backdrop-blur-sm">
                <UserIcon className="w-8 h-8" />
              </div>
            </div>
            
            <h2 className="text-xl font-bold mb-2">Student</h2>
            <p className="text-blue-100 text-sm">
              Learn with interactive stories and voice conversations
            </p>
          </div>
        </button>

        {/* Teacher Role */}
        <button
          onClick={() => onRoleSelected('teacher')}
          className="group relative overflow-hidden p-6 rounded-2xl bg-gradient-to-br from-green-500 to-teal-600 text-white hover:from-green-600 hover:to-teal-700 transform hover:scale-105 transition-all duration-300 shadow-xl hover:shadow-2xl"
        >
          <div className="absolute inset-0 bg-white/10 group-hover:bg-white/20 transition-colors duration-300" />
          
          <div className="relative z-10 text-center">
            <div className="mb-4 flex justify-center">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center backdrop-blur-sm">
                <TeacherIcon className="w-8 h-8" />
              </div>
            </div>
            
            <h2 className="text-xl font-bold mb-2">Teacher</h2>
            <p className="text-green-100 text-sm">
              Manage stories, track progress, and view insights
            </p>
          </div>
        </button>
      </div>

      <div className="mt-6 text-center">
        <p className="text-xs text-gray-500">
          Select your role to access the appropriate features
        </p>
      </div>
    </div>
  );
}